export enum SectionState {
  Loading = 'Loading',
  LoadingTransparent = 'LoadingTransparent',
  HideLoading = 'HideLoading',
  Ready = 'Ready',
  Disconnected = 'Disconnected',
  Error = 'Error',
  Empty = 'Empty',
  SearchResultEmpty = 'SearchResultEmpty',
  ComingSoon = 'ComingSoon',
}

export enum UploadingStatus {
  Done = 'done',
  Uploading = 'uploading',
  Error = 'error',
}

export enum drawingType {
  Drawing = 'Drawing',
  NonDrawing = 'NonDrawing',
}

export enum ScreenType {
  phone = 'phone',
  tablet = 'tablet',
  desktop = 'desktop',
}

export enum ScreenSizes {
  xs = 0,
  sm = 599,
  md = 959,
  lg = 1279,
  xl = 1559,
  xxl = 1919,
  xxxl = 2999,
}

export enum DrawerPosition {
  Start = 'start',
  End = 'end',
}

export enum DrawerMode {
  Side = 'side',
  Over = 'over',
  Push = 'push',
}

export enum DrawerType {
  MobileMenu = 'mobileMenu',
  Notifications = 'notifications',
  ProfileMenu = 'profileMenu',
  Filters = 'filters',
  ColumnOptions = 'columnOptions',
  Chat = 'chat',
}


export enum Themes {
  main = 'main',
  purple = 'purple',
  green = 'green',
  'deep-orange' = 'deep-orange',
  teal = 'teal',
  cyan = 'cyan',
}

export enum ColorPerTheme {
  main = '#172E63',
  purple = '#673AB7',
  green = '#4CAF50',
  'deep-orange' = '#FF5722',
  teal = '#009688',
  cyan = '#189dd6',
  'dark-blue' = '#1c2346'
}

export enum ColorPalette {
  Primary = 'primary',
  Accent = 'accent',
  Success = 'success',
  Warn = 'warn',
  Default = 'default',
}


export enum ColumnOptionsListPage {
  TrucksReport = 'TRUCKS_REPORT',
  ConsolidationsReport = 'CONSOLIDATION_REPORT',
  DriversReport = 'DRIVERS_REPORT',
  ShipmentList = 'SHIPMENT_LIST',
  CustomerShipmentList = 'CUSTOMER_SHIPMENT_LIST',
  FleetShipmentList = 'FLEET_SHIPMENT_LIST',
  SAASShipmentList = 'SAAS_SHIPMENT_LIST',
  OrganizationShipmentList = 'ORGANIZATION_SHIPMENT_LIST',
  BulkShipments = 'BULK_SHIPMENTS'
}
